import { Translation } from "./index";

const de: Translation = {
  components: {
    searchProduct: "Produkt suchen",
    withoutBarCode: "ohne Strichcode",
    stillHereModal: {
      title: "Sind Sie noch da?",
      closingIn: "Falls nicht, werden wir in <0>{{count}} Sekunden schließen.</0>",
      nextCustomer: "Nächster Kunde",
      stillHere: "Ja, ich bin noch da",
    },
    receipt: {
      vat: "MwSt",
      deposit: "Pfand",
      yourReceipt: "Ihre Quittung",
      subtotal: "Zwischensumme",
    },
  },
  startPage: {
    title: "Scannen & Bezahlen",
    scanBarCode: "Scannen Sie den Barcode oder drücken Sie Start",
    version: "Version: {{version}}",
    pickupTitle: "Was würden Sie später gerne sammeln?",
    pickupSubtitle: "Start drücken, um eine Bestellung aufzugeben",
  },
  mainPage: {
    pageTitle: "Scannen Sie Ihre Produkte",
    pickupPageTitle: "Abholmenü bestellen",
    checkout: "Bezahlen",
    productSearch: "Produkt suchen",
    selectCategory: "Kategorie auswählen",
    yourReceipt: "Ihre Quittung",
    emptyReceiptText: "Scannen Sie Ihre Produkte und Rabattgutscheine",
    emptyPickupReceiptText: "Wählen Sie die Produkte, die Sie bestellen möchten",
    foundProducts: "Gefundene Produkte",
    typeProduct: "Produkttyp...",
    ageCheckModal: {
      title: "Sind Sie {{ age }} Jahre oder älter?",
      message: "Wir verkaufen alkoholische Produkte nur, wenn Sie älter als {{ age }} Jahre sind.",
      confirmText: "Ja, ich bin {{ age }} oder älter",
      cancelText: "Nein",
    },
    combiDeals: {
      title: "Profitieren Sie jetzt von dem Kombi-Angebot!",
      message:
        "Scannen Sie oder wählen Sie eines der untenstehenden Produkte und sparen Sie {{ price }}!",
      noPriceMessage:
        "Scannen Sie oder wählen Sie eines der untenstehenden Produkte und sparen Sie.",
      deal: "Kombi-Angebot!",
    },
    invalidQrScan: {
      title: "Ungültiger QR-Code",
      message:
        "Der gescannte QR-Code ist ungültig, bitte versuchen Sie es erneut oder gehen Sie zur Rezeption.",
    },
    ageCheckValid: "{{ age }}+ Produkte können jetzt hinzugefügt werden.",
    productNotFound: "Gescannter Artikel nicht gefunden",
    productNotFoundDescription:
      "Wir erkennen den gescannten Artikel nicht, bitte versuchen Sie es erneut oder gehen Sie zur Rezeption.",
    vouchers: {
      doYouHave: "Haben Sie einen <0>Rabattgutschein?</0>",
      scanForDiscount: "Scannen Sie den Gutschein für Rabatt",
      notValidTitle: "Dieser QR ist ungültig",
    },
    errors: {
      unknownErrorTitle: "Unbekanntes Problem aufgetreten",
      unknownErrorDescription:
        "Es ist ein unbekanntes Problem aufgetreten. Bitte versuchen Sie es erneut oder melden Sie sich an unserer Rezeption.",
      notFoundTitle: "Gescannter Gutschein nicht gefunden",
      notFoundDescription:
        "Wir erkennen den eingescannten Gutschein nicht an, bitte versuchen Sie es erneut oder oder melden Sie sich an unserer Rezeption.",
      addEligibleProductDescription: "Fügen Sie ein Produkt hinzu.",
    },
  },
  checkoutPage: {
    followTerminal: "Folgen Sie der Zahlung am Zahlungsterminal.",
  },
  verificationPage: {
    title: "Um zu bestätigen, dass Sie {{ age }}+ sind, scannen Sie bitte einen QR-Code.",
    verifiedID:
      "Haben Sie eine verifizierte RestaurantID (erkennbar am goldenen Häkchen) in der Valk Exclusief App? Scannen Sie dann Ihre RestaurantID.",
    or: "ODER",
    getCodeAtReception: "Holen Sie sich einen QR-Code an der Rezeption.",
  },
  successPage: {
    paid: "Sie haben bezahlt.",
    digitalReceipt: "Digitale Quittung",
    review: "Bewerten Sie uns.",
    tip: "Haben Sie noch einen Tipp für uns?",
    selectStars: "Wählen Sie die Anzahl der Sterne",
    sendReview: "Versenden",
    thanks: "Danke für die Rückmeldung!",
    scanQr:
      "Scannen Sie den QR-Code oder geben Sie Ihre E-Mail-Adresse ein, um eine PDF Ihrer Quittung zu erhalten.",
    sendReceipt: "Beleg senden",
    fillInEmailForReceipt:
      "Möchten Sie den Beleg digital erhalten? Geben Sie unten Ihre E-Mail-Adresse ein.",
    emailError:
      "Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut oder gehen Sie zur Rezeption.",
    emailSent: "Gesendet",
    hasSentReceipt: "Die E-Mail wurde gesendet!",
  },
  errorScreen: {
    title: "Etwas ist schiefgelaufen, es tut uns leid. Bitte versuchen Sie es erneut.",
    subTitle: "Geht etwas erneut schief? Bitte melden Sie sich an der Rezeption.",
    noInternetTitle: "Keine Internetverbindung. Bitte versuchen Sie es erneut.",
  },
  failedPayment: {
    title: "Zahlung fehlgeschlagen!",
    backToReceipt: "Zurück zur Quittung",
    startOver: "Neu anfangen",
  },
  pickup: {
    timeSlotPage: {
      title: "Wählen Sie Ihre Abholzeit",
      otherOptions: "Andere Möglichkeiten:",
      tomorrow: "Morgen",
    },
    yourInfoPage: {
      yourInfo: "Ihre Daten",
      personalInfo: "Persönliche Daten",
      firstName: "Vornamen",
      lastName: "Nachname",
      emailAddress: "E-Mail Adresse",
      phoneNumber: "Telefonnummer",
      emailDesc: "Die digitale Quittung senden wir an diese E-Mail-Adresse.",
      phoneNumberDesc: "Sollten Fragen zu Ihrer Bestellung bestehen",
      pay: "Bezahlen",
      chosenTimeSlot: "Die von Ihnen gewählte Abholzeit",
      errors: {
        firstName: "Bitte geben Sie Ihren Vornamen ein",
        lastName: "Bitte geben Sie Ihren Nachnamen ein",
        emailAddress: "Bitte geben Sie eine gültige Telefonnummer ein",
        phoneNumber: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      },
    },
    successPage: {
      thanks: "Vielen Dank für Ihre Bestellung!",
      emailConfirmation: "Wir senden die Bestätigung und die Quittung an <0>{{ email }}</0>",
    },
  },
  ui: {
    start: "Start",
    total: "Gesamtbetrag",
    search: "Suchen",
    cancel: "Abbrachen",
    tryAgain: "Erneut versuchen",
    yourEmail: "Ihre E-Mail-Adresse",
    close: "Schließen",
    no: "Nein",
    closeModal: "Schließen",
    back: "Zurück",
    continue: "Weiter",
    from: "Ab",
  },
};

export default de;
